import React from 'react';
import useStyles from '../../screens/Main/Main.style';
import WarningIcon from '@material-ui/icons/Warning';
import {
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Box,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const DeleteOption = ({
  message,
  openDeleteDialog,
  fullScreen,
  onClickYes,
  handleClose,
  usersAlongWithEntity,
  entity,
}) => {
  const classes = useStyles();

  return (
    <>
      <Dialog
        className={classes.dialogOuterMedium}
        fullScreen={fullScreen}
        open={openDeleteDialog}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle className={classes.dialogTitle} id="responsive-dialog-title">
          {usersAlongWithEntity ? (
            <Typography align="left" variant="h2" component="span">
              <Box className={classes.RedWarningIcon} display="flex" mr={1}>
                <WarningIcon />
              </Box>
              Alert
            </Typography>
          ) : (
            <Typography align="left" variant="h2" component="span">
              {message}
            </Typography>
          )}

          <IconButton aria-label="close" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent style={{ paddingBottom: '30px' }}>
          {usersAlongWithEntity ? (
            <Typography align="left" variant="h5" component="span">
              This {entity} is currently linked to one or more employees.
              <br />
              <br />
              Please ensure they are either unlinked or reassigned to another {entity} before
              proceeding with deletion.
            </Typography>
          ) : (
            <></>
          )}
        </DialogContent>
        <DialogActions style={{ display: usersAlongWithEntity ? 'none' : '' }}>
          <Button onClick={onClickYes} color="primary" variant="contained" autoFocus>
            Yes
          </Button>
          <Button
            onClick={handleClose}
            className={classes.secondaryBtnUI}
            variant="outlined"
            color="secondary"
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteOption;
